/* @flow */

const { screen } = global

const dummy = (orientation) => {
  console.warn(`[Screen] Can't lock the orientantion at "${orientation.toString()}"`)
}

export default function orientationLock(orientation) {
  return new Promise(resolve => {
    if (screen.orientation && screen.orientation.lock) {
      // Chrome: Prevent promisse unhandled exception on desktops
      screen.orientation.lock(orientation).catch(() => null)
      resolve()
    } else {
      const lockOrientation = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation || dummy
      lockOrientation(orientation)
      resolve()
    }
  })
}
